module.exports = __webpack_public_path__ + "static/media/OpenSans-Light.7d9b2e9d.svg";